// Fixed rather than generated: the modal and drawer options naming the dialog are built
// outside of the (lazy-loaded) content that renders the title, and one is open at a time.
export const ADD_TO_CART_MODAL_TITLE_ID = 'add-to-cart-modal-title';
